module.exports = {"data":[{"date":"January","client":"2801"},{"date":"February","client":"3091"},{"date":"March","client":"3259"},{"date":"April","client":"5176"},{"date":"May","client":"4600"},{"date":"June","client":"4674"},{"date":"July","client":"4005"},{"date":"August","client":"4348"},{"date":"September","client":"3544"},{"date":"October","client":"3588"},{"date":"November","client":"1393"},{"date":"December","client":"1262"}]}


//////////////////
// WEBPACK FOOTER
// ./static/clients_per_month.json
// module id = 495
// module chunks = 1